<template>
  <div>
    <modal-provider
      name="sorting-modal"
      :title="$t(`search.filters.sorting`)"
      :width="330"
      classList=""
    >
      <div ref="modal" class="modal" tabindex="0">
        <SearchSortingList
          v-if="Array.isArray(searchPageInfo && searchPageInfo.sorts)"
          :sorts="searchPageInfo && searchPageInfo.sorts"
          @optionChanged="hideModal"
        />
      </div>
    </modal-provider>
  </div>
</template>

<script>
import SearchSortingList from '@/components/search-page/SearchSortingList.vue'
import { mapState } from 'vuex'

export default {
  name: 'SortingModal',
  components: { SearchSortingList },
  methods: {
    hideModal () {
      this.$modal.hide('sorting-modal')
    }
  },
  computed: {
    ...mapState({
      searchPageInfo: state => state.search.searchPageInfo
    })
  }
}
</script>

<style scoped lang="sass">
  ::v-deep .modal__title
    margin-bottom: 0
</style>
